import {useController} from "react-hook-form";
import store from "storejs";
import { useMemo, useState} from "react";
import RadioGroup from "./../RadioGroup";
import {ONE_TIME} from "../../Constants/PaymentTypes";

import block from "bem-css-modules";

import s from './OneTimePayment.module.scss';
import {useGetDefaultCountry} from "../../Hooks/useGetDefaultCountry";
import {useTranslation} from "react-i18next";

const b = block(s);

const OneTimePayment = ({control, name}) => {
    const {t} = useTranslation('countries');
    const defaultCountry = useGetDefaultCountry();
    const [country, setCountry] = useState(defaultCountry);
    const {
        field: {onChange, onBlur, value},
        fieldState: {error},
    } = useController({
        name,
        control,
        rules: {required: true},
    })

    const oneTime = useMemo(() => store(ONE_TIME), []);
    const countries = useMemo(() => Object.keys(oneTime).map(id => {
        return {id, label: t(id.toLowerCase())}
    }), [oneTime, t]);
    const methods = oneTime[country];

    return <div className={b()}>
        <div className={b('countries')}>
            <RadioGroup onChange={(e) => setCountry(e.target.value)} value={country} items={countries}/>
        </div>
        <div>
            <RadioGroup onBlur={onBlur} onChange={onChange} value={value} items={methods} name={name} error={error}/>
        </div>
        <span className='error'>{error?.message}</span>
    </div>
}

export default OneTimePayment;